// extracted by mini-css-extract-plugin
export default {"formHeading":"CJ-z","form":"DJ-z","submitBtn":"EJ-z","disabled":"FJ-z","input":"GJ-z","error":"HJ-z","submitMsg":"IJ-z","signIn":"JJ-z"};